export const stateOptions = [
  { value: "", label: "Select a State" },
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
];

export const marks = [
  { value: 0, label: "0" },
  { value: 250, label: "250" },
  { value: 500, label: "500" },
  { value: 750, label: "750" },
  { value: 1000, label: "1000" },
  { value: 1250, label: "1250" },
  { value: 1500, label: "1500" },
  { value: 1750, label: "1750" },
  { value: 2000, label: "2000" },
  { value: 2250, label: "2250" },
  { value: 2500, label: "2500" },
];

export const yearsArray = [
  { id: 1, value: 2000 },
  { id: 2, value: 2001 },
  { id: 3, value: 2002 },
  { id: 4, value: 2003 },
  { id: 5, value: 2004 },
  { id: 6, value: 2005 },
  { id: 7, value: 2006 },
  { id: 8, value: 2007 },
  { id: 9, value: 2008 },
  { id: 10, value: 2009 },
  { id: 11, value: 2010 },
  { id: 12, value: 2011 },
  { id: 13, value: 2012 },
  { id: 14, value: 2013 },
  { id: 15, value: 2014 },
  { id: 16, value: 2015 },
  { id: 17, value: 2016 },
  { id: 18, value: 2017 },
  { id: 19, value: 2018 },
  { id: 20, value: 2019 },
  { id: 21, value: 2020 },
  { id: 22, value: 2021 },
  { id: 23, value: 2022 },
  { id: 24, value: 2023 },
];
export const carMakes = [
  { id: 1, value: "Acura" },
  { id: 2, value: "Alfa Romeo" },
  { id: 3, value: "Aston Martin" },
  { id: 4, value: "Audi" },
  { id: 5, value: "Bentley" },
  { id: 6, value: "BMW" },
  { id: 7, value: "Buick" },
  { id: 8, value: "Cadillac" },
  { id: 9, value: "Chevrolet" },
  { id: 10, value: "Chrysler" },
  { id: 11, value: "Dodge" },
  { id: 12, value: "Ferrari" },
  { id: 13, value: "Fiat" },
  { id: 14, value: "Ford" },
  { id: 15, value: "Genesis" },
  { id: 16, value: "GMC" },
  { id: 17, value: "Honda" },
  { id: 18, value: "Hyundai" },
  { id: 19, value: "Infiniti" },
  { id: 20, value: "Jaguar" },
  { id: 21, value: "Jeep" },
  { id: 22, value: "Kia" },
  { id: 23, value: "Lamborghini" },
  { id: 24, value: "Land Rover" },
  { id: 25, value: "Lexus" },
  { id: 26, value: "Lincoln" },
  { id: 27, value: "Lotus" },
  { id: 28, value: "Maserati" },
  { id: 29, value: "Mazda" },
  { id: 30, value: "McLaren" },
  { id: 31, value: "Mercedes-Benz" },
  { id: 32, value: "MINI" },
  { id: 33, value: "Mitsubishi" },
  { id: 34, value: "Nissan" },
  { id: 35, value: "Porsche" },
  { id: 36, value: "RAM" },
  { id: 37, value: "Rolls-Royce" },
  { id: 38, value: "Subaru" },
  { id: 39, value: "Tesla" },
  { id: 40, value: "Toyota" },
  { id: 41, value: "Volkswagen" },
  { id: 42, value: "Volvo" },
];

export const bodyStyleData = [
  {
    id: 1,
    name: "SUV",
    total: "250",
    checked: false,
  },
  {
    id: 2,
    name: "Sedan",
    total: "1250",
    checked: false,
  },
  {
    id: 3,
    name: "Pickup",
    total: "2000",
    checked: false,
  },
  {
    id: 4,
    name: "Hatchback",
    total: "1200",
    checked: false,
  },
  {
    id: 5,
    name: "Minivan",
    total: "120",
    checked: false,
  },
  {
    id: 6,
    name: "Coupe",
    total: "123",
    checked: false,
  },
  {
    id: 7,
    name: "Convertible",
    total: "122",
    checked: false,
  },
  {
    id: 8,
    name: "Van",
    total: "167",
    checked: false,
  },
  {
    id: 9,
    name: "Chassis",
    total: "24",
    checked: false,
  },
];
export const carEngineTypes = [
  { id: 1, name: "V4", total: 2314, checked: false },
  { id: 2, name: "V6", total: 1262, checked: false },
  { id: 3, name: "V8", total: 628, checked: false },
  { id: 4, name: "V3", total: 263, checked: false },
  { id: 5, name: "V5", total: 112, checked: false },
  { id: 6, name: "V10", total: 3, checked: false },
  { id: 7, name: "V12", total: 6, checked: false },
  { id: 8, name: "Electric", total: 65, checked: false },
];
export const carFuelTypes = [
  { id: 1, name: "Gasoline", total: "n/a", checked: false },
  { id: 2, name: "Diesel", total: "n/a", checked: false },
  { id: 3, name: "Electric", total: "n/a", checked: false },
  { id: 4, name: "Hybrid Gasoline", total: "n/a", checked: false },
  { id: 5, name: "Hybrid Diesel", total: "n/a", checked: false },
  { id: 6, name: "Hybrid Electric", total: "n/a", checked: false },
  { id: 7, name: "Plug-in Hybrid Gasoline", total: "n/a", checked: false },
  { id: 8, name: "Plug-in Hybrid Diesel", total: "n/a", checked: false },
  { id: 9, name: "Plug-in Hybrid Electric", total: "n/a", checked: false },
  { id: 10, name: "Natural Gas", total: "n/a", checked: false },
  { id: 11, name: "Propane", total: "n/a", checked: false },
];

export const carTransmissionTypes = [
  { id: 1, name: "Manual", total: 187, checked: false },
  { id: 2, name: "Automatic", total: 765, checked: false },
  { id: 3, name: "Unknown", total: 43, checked: false },
];
export const drivetrains = [
  { id: 1, name: "FDW", total: 2120, checked: false },
  { id: 2, name: "AWD", total: 1285, checked: false },
  { id: 3, name: "4WD", total: 1370, checked: false },
  { id: 4, name: "RWD", total: 260, checked: false },
  { id: 5, name: "unidentified", total: 2240, checked: false }
];
export const bodyColors = [
  { id: 1, name: "White", total: 250, checked: false },
  { id: 2, name: "Black", total: 200, checked: false },
  { id: 3, name: "Gray", total: 150, checked: false },
  { id: 4, name: "Silver", total: 100, checked: false },
  { id: 5, name: "Red", total: 90, checked: false },
  { id: 6, name: "Blue", total: 80, checked: false },
  { id: 7, name: "Green", total: 70, checked: false },
  { id: 8, name: "Yellow", total: 30, checked: false },
  { id: 9, name: "Orange", total: 20, checked: false },
  { id: 10, name: "Purple", total: 10, checked: false },
];
export const interiorColors = [
  { id: 1, name: "Black", total: 300, checked: false },
  { id: 2, name: "Gray", total: 200, checked: false },
  { id: 3, name: "Beige", total: 150, checked: false },
  { id: 4, name: "Brown", total: 100, checked: false },
  { id: 5, name: "Tan", total: 90, checked: false },
  { id: 6, name: "Red", total: 80, checked: false },
  { id: 7, name: "White", total: 70, checked: false },
  { id: 8, name: "Blue", total: 30, checked: false },
  { id: 9, name: "Green", total: 20, checked: false },
  { id: 10, name: "Other", total: 10, checked: false },
];
export const otherOptions = [
  { id: 1, name: "Sunroof/Moonroof", total: 350, checked: false },
  { id: 2, name: "Leather Seats", total: 300, checked: false },
  { id: 3, name: "Navigation System", total: 250, checked: false },
  { id: 4, name: "Bluetooth", total: 200, checked: false },
  { id: 5, name: "Backup Camera", total: 150, checked: false },
  { id: 6, name: "Premium Sound System", total: 100, checked: false },
  { id: 7, name: "Keyless Entry/Start", total: 80, checked: false },
  { id: 8, name: "Remote Start", total: 60, checked: false },
  { id: 9, name: "Heated Seats", total: 50, checked: false },
  { id: 10, name: "Cooled Seats", total: 40, checked: false },
  { id: 11, name: "Blind Spot Monitoring", total: 30, checked: false },
  { id: 12, name: "Adaptive Cruise Control", total: 20, checked: false },
  { id: 13, name: "Parking Sensors", total: 10, checked: false },
];

export const sideNavData = [
  {
    id: 1,
    title: "Location",
    submenu: {
      title: "distacnce with in",
      min: 0,
      max: 1500,
    },
    component: "range",
    label: "distance",
  },
  {
    id: 2,
    title: "Selected Make",
    submenu: carMakes,
    component: "select",
    label: "Make",
  },
  {
    id: 3,
    title: "Year",
    submenu: yearsArray,
    component: "select",
    label: "select year",
  },
  {
    id: 4,
    title: "Price",
    submenu: {},
    component: "range",
    label: "max price",
  },
  {
    id: 5,
    title: "Milage",
    submenu: {},
    component: "range",
    label: "max mileage",
  },
  {
    id: 6,
    title: "Body Style",
    submenu: bodyStyleData,
    component: "checkbox",
    label: "choose body style",
  },
  {
    id: 7,
    title: "Cylinder",
    submenu: carEngineTypes,
    component: "checkbox",
    label: "Engine",
  },
  {
    id: 8,
    title: "Fule Type",
    submenu: carFuelTypes,
    component: "checkbox",
    label: "Fuel Type",
  },
  {
    id: 9,
    title: "Transmission",
    submenu: carTransmissionTypes,
    component: "checkbox",
    label: "Transmission",
  },
  {
    id: 10,
    title: "Drivetrain",
    submenu: drivetrains,
    component: "checkbox",
    label: "Drivetrain",
  },
  {
    id: 11,
    title: "Body Color",
    submenu: bodyColors,
    component: "checkbox",
    label: "Body Color",
  },
  {
    id: 12,
    title: "Interior Color",
    submenu: interiorColors,
    component: "checkbox",
    label: "Interior Color",
  },
  {
    id: 13,
    title: "Other Options",
    submenu: otherOptions,
    component: "checkbox",
    label: "Other Options",
  }
];

export const initialSearchState = [
  {
    id: 1,
    value: 100,
    title: "Location",
  },
  {
    id: 2,
    value: "All",
    title: "Selected Make",
  },
  {
    id: 3,
    value: 2000,
    title: "Year",
  },
  {
    id: 4,
    value: "Any Price",
    title: "Price",
  },
  {
    id: 5,
    value: "Any Mileage",
    title: "Milage",
  },
  {
    id: 6,
    value: "Any Style",
    status: bodyStyleData,
    title: "Body Style",
  },
  {
    id: 7,
    value: "",
    status: carEngineTypes,
    title: "Engine type",
  },
  {
    id: 8,
    value: "",
    status: carFuelTypes,
    title: "Fule Type",
  },
  {
    id: 9,
    value: "",
    status: carTransmissionTypes,
    title: "Transmission",
  },
  {
    id: 10,
    value: "",
    status: drivetrains,
    title: "Drivetrain",
  },
  {
    id: 11,
    value: "",
    status: bodyColors,
    title: "Body Color",
  },
  {
    id: 12,
    value: "",
    status: interiorColors,
    title: "Interior Color",
  },
  {
    id: 13,
    value: "",
    status: otherOptions,
    title: "Other Options",
  },
  {
    id: 14,
    value: "Used",
    title: "Condition",
  },
];
